export const PANELS = {
	ADD_SHAPE: {
		id: "AddShapePanel",
		title: "Add shape",
	},

	CANVAS_SETTINGS: {
		id: "CanvasSettingsPanel",
		title: "Canvas options",
	},

    ADD_TEXT: {
		id: "AddTextPanel",
		title: "Add text",
	},

	TEXT_SETTINGS: {
		id: "TextSettingsPanel",
		title: "Text options",
	},

	ADD_IMAGE: {
		id: "AddImagePanel",
		title: "Add media",
	},

	IMAGE_SETTINGS: {
		id: "ImageSettingsPanel",
		title: "Image options",
	},


	IMAGE: { name: "Image", icon: "Image", defaultHeight: 10, minHeight: 2 },

	VIDEO: { name: "Video", icon: "Video", defaultHeight: 10 },

	TABLE: { name: "Table", icon: "Table", defaultHeight: 6 },

	CHART: { name: "Chart", icon: "LineChart", defaultHeight: 8 },

	CODE: { name: "Code", icon: "Code", defaultHeight: 6 },

	WEB: { name: "Web", icon: "Web", defaultHeight: 8 },

	TWITTER: { name: "Twitter", icon: "Twitter", defaultHeight: 8 },

	GIPHY: { name: "Giphy", icon: "Giphy", defaultHeight: 8 },

	AIRTABLE: { name: "Airtable", icon: "Airtable", defaultHeight: 8 },

	FIGMA: { name: "Figma", icon: "Figma", defaultHeight: 8 },

	DALLE: { name: "Dalle", icon: "Dalle", defaultHeight: 8 },

	FRAMER: { name: "Framer", icon: "Framer", defaultHeight: 8 },

	MIRO: { name: "Miro", icon: "Miro", defaultHeight: 8 },

	LOOKER: { name: "Looker", icon: "Looker", defaultHeight: 8 },

	COLOR: { name: "Color", icon: "PaintBucket", defaultHeight: 8 },

	BACKGROUND: { name: "Background", icon: "Background", defaultHeight: 8 },
};
